import { createApp } from 'vue';
import GlobalUploadComponent from '../components/uploadArtwork/GlobalUploadComponent';

function globalUploadApp(opts) {
  const config = {
    dom: {
      parent: 'globalUploadApp',
    },
  };

  const c = __.extend(config, opts);

  const $parent = document.getElementById(c.dom.parent);
  function init() {
    if (!$parent) return;

    const app = createApp(GlobalUploadComponent);

    app.mount(`#${c.dom.parent}`);
  }

  init();
}

export default globalUploadApp;
